"use strict";
var race_1 = require('../operator/race');
exports.race = race_1.raceStatic;
//# sourceMappingURL=race.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/race.js
// module id = 532
// module chunks = 1